import {useContext} from 'react';
import {AppContext} from '../components/AppContext';

const useAppContext = () => useContext(AppContext);

export default useAppContext;
